/* Liquid Gold Ops — Kino Clinic
   All runtime behavior lives under `window.LiquidGold.kino.*`.
   Boot dispatcher at the bottom wires each module on DOMContentLoaded. */

(function () {
  'use strict';

  window.LiquidGold = window.LiquidGold || {};
  window.LiquidGold.kino = window.LiquidGold.kino || {};
  var ns = window.LiquidGold.kino;

  ns.nav = {
    init: function () {
      var header = document.querySelector('header-component');
      if (!header) return;
      var threshold = 40;
      var update = function () {
        if (window.scrollY > threshold) {
          header.classList.add('is-lg-scrolled');
        } else {
          header.classList.remove('is-lg-scrolled');
        }
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
    },
  };

  // Mobile menu: reuse Horizon's native drawer — no-op placeholder.
  ns.mobileMenu = {
    init: function () {},
  };

  ns.countUp = {
    init: function () {
      var els = document.querySelectorAll('[data-lg-count]');
      if (!els.length) return;

      var format = function (el, value) {
        var raw = el.dataset.lgCount || '';
        var decimals = raw.indexOf('.') !== -1 ? 1 : 0;
        el.textContent = value.toFixed(decimals);
      };

      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduced || typeof IntersectionObserver === 'undefined') {
        els.forEach(function (el) {
          var target = parseFloat(el.dataset.lgCount);
          if (!isNaN(target)) format(el, target);
        });
        return;
      }

      var easeOut = function (t) {
        return 1 - Math.pow(1 - t, 3);
      };

      var animate = function (el) {
        if (el.dataset.lgCounted) return;
        el.dataset.lgCounted = '1';
        var target = parseFloat(el.dataset.lgCount);
        if (isNaN(target)) return;
        var duration = 1200;
        var start = null;
        var tick = function (ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          format(el, target * easeOut(progress));
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animate(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35, rootMargin: '0px 0px -15% 0px' }
      );

      els.forEach(function (el) {
        observer.observe(el);
      });
    },
  };

  ns.ctaFinal = {
    init: function () {
      var containers = document.querySelectorAll('.lg-kino-cta-final');
      if (!containers.length) return;

      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      containers.forEach(function (container) {
        var lines = container.querySelectorAll('.lg-kino-cta-final__line');
        var labels = container.querySelectorAll('.lg-kino-cta-final__media-label');
        if (!lines.length) return;

        var setActive = function (index) {
          lines.forEach(function (line, i) {
            line.classList.toggle('is-on', i === index);
          });
          var activeLine = lines[index];
          if (!activeLine) return;
          var activeLabel = activeLine.getAttribute('data-label') || '';
          labels.forEach(function (label) {
            label.classList.toggle(
              'is-on',
              label.getAttribute('data-label') === activeLabel
            );
          });
        };

        if (reduced) {
          lines.forEach(function (line) {
            line.classList.add('is-on');
          });
          labels.forEach(function (label) {
            label.classList.add('is-on');
          });
          return;
        }

        var index = 0;
        var timer = null;
        var tick = function () {
          index = (index + 1) % lines.length;
          setActive(index);
        };

        setActive(0);

        if (typeof IntersectionObserver === 'undefined') {
          timer = setInterval(tick, 2400);
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (!timer) timer = setInterval(tick, 2400);
              } else if (timer) {
                clearInterval(timer);
                timer = null;
              }
            });
          },
          { threshold: 0.35 }
        );
        observer.observe(container);
      });
    },
  };

  ns.modals = {
    init: function () {
      var focusableSelector =
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

      var lastFocus = null;
      var openModal = null;

      var getFocusables = function (root) {
        return Array.prototype.slice
          .call(root.querySelectorAll(focusableSelector))
          .filter(function (el) {
            return !el.hasAttribute('disabled') && el.offsetParent !== null;
          });
      };

      var trapFocus = function (e) {
        if (!openModal) return;
        var dialog = openModal.querySelector('.lg-kino-modal__dialog');
        if (!dialog) return;
        var items = getFocusables(dialog);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };

      var close = function (modal) {
        if (!modal) return;
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('lg-kino-modal-open');
        var dialog = modal.querySelector('.lg-kino-modal__dialog');
        var finish = function () {
          modal.hidden = true;
          if (dialog) dialog.removeEventListener('transitionend', finish);
        };
        if (dialog) {
          dialog.addEventListener('transitionend', finish);
          // Fallback in case transitionend never fires (reduced-motion, etc.)
          setTimeout(finish, 400);
        } else {
          finish();
        }
        if (modal === openModal) {
          openModal = null;
          if (lastFocus && typeof lastFocus.focus === 'function') {
            lastFocus.focus();
          }
        }
      };

      var open = function (modal) {
        if (!modal || openModal === modal) return;
        if (openModal) close(openModal);
        lastFocus = document.activeElement;
        modal.hidden = false;
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
        document.documentElement.classList.add('lg-kino-modal-open');
        openModal = modal;
        var dialog = modal.querySelector('.lg-kino-modal__dialog');
        if (dialog) {
          var firstFocusable = getFocusables(dialog)[0];
          if (firstFocusable) firstFocusable.focus();
        }
      };

      document.addEventListener('keydown', function (e) {
        // Activate non-native triggers (role="button" media, etc.) via Enter/Space.
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          var target = e.target;
          if (
            target &&
            target.matches &&
            target.matches('[data-lg-open-protocol]') &&
            target.tagName !== 'BUTTON' &&
            target.tagName !== 'A'
          ) {
            e.preventDefault();
            var protocolModalKb = document.getElementById('lg-kino-modal-protocol');
            if (protocolModalKb) open(protocolModalKb);
            return;
          }
        }

        if (!openModal) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close(openModal);
        } else if (e.key === 'Tab') {
          trapFocus(e);
        }
      });

      document.addEventListener('click', function (e) {
        var openTrigger = e.target.closest('[data-lg-open-protocol]');
        if (openTrigger) {
          e.preventDefault();
          var protocolModal = document.getElementById('lg-kino-modal-protocol');
          if (protocolModal) open(protocolModal);
          return;
        }

        var closeTrigger = e.target.closest('[data-lg-modal-close]');
        if (closeTrigger) {
          e.preventDefault();
          var modalRoot = closeTrigger.closest('.lg-kino-modal') || openModal;
          if (modalRoot) close(modalRoot);
        }
      });

      var protocolModal = document.getElementById('lg-kino-modal-protocol');
      if (protocolModal) {
        var items = protocolModal.querySelectorAll('[data-lg-protocol-value]');
        var continueEl = protocolModal.querySelector('[data-lg-protocol-continue]');

        var setActive = function (target) {
          if (target.classList.contains('is-disabled')) return;
          items.forEach(function (item) {
            var isActive = item === target;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            item.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });
          if (continueEl) {
            var href = target.getAttribute('data-lg-href') || '#';
            continueEl.setAttribute('href', href);
          }
        };

        items.forEach(function (item) {
          item.addEventListener('click', function () {
            setActive(item);
          });
          item.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setActive(item);
            }
          });
        });
      }

      var legalModal = document.getElementById('lg-kino-modal-legal');
      if (legalModal) {
        var tabs = legalModal.querySelectorAll('[role="tab"]');
        var panels = legalModal.querySelectorAll('[role="tabpanel"]');

        var selectTab = function (key) {
          tabs.forEach(function (tab) {
            var isSelected = tab.getAttribute('data-lg-tab') === key;
            tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            tab.tabIndex = isSelected ? 0 : -1;
          });
          panels.forEach(function (panel) {
            panel.classList.toggle(
              'is-active',
              panel.getAttribute('data-lg-panel') === key
            );
          });
        };

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var key = tab.getAttribute('data-lg-tab');
            if (key) selectTab(key);
          });
        });

        document.addEventListener('click', function (e) {
          var link = e.target.closest('a');
          if (!link) return;
          var key = link.getAttribute('data-legal');
          if (!key) {
            var href = link.getAttribute('href') || '';
            var m = href.match(/^#legal-(privacy|terms|disclosures)$/);
            if (m) key = m[1];
          }
          if (!key) return;
          e.preventDefault();
          selectTab(key);
          open(legalModal);
        });
      }
    },
  };

  // "How it works" — self-drawing SVG card borders + scroll-triggered reveal.
  ns.how = {
    init: function () {
      var grids = document.querySelectorAll('.lg-kino-how__grid');
      if (!grids.length) return;

      var reduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      Array.prototype.forEach.call(grids, function (grid) {
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.lg-kino-how__step'));
        if (!cards.length) return;

        // Recompute each border rect to the live card box (0.6 inset, rx 6).
        var sizeBorders = function () {
          cards.forEach(function (card) {
            var svg = card.querySelector('.lg-kino-how__border');
            var rect = svg && svg.querySelector('rect');
            if (!svg || !rect) return;
            var w = card.offsetWidth;
            var h = card.offsetHeight;
            if (!w || !h) return;
            svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
            rect.setAttribute('x', 0.6);
            rect.setAttribute('y', 0.6);
            rect.setAttribute('width', w - 1.2);
            rect.setAttribute('height', h - 1.2);
            rect.setAttribute('rx', 6);
          });
        };

        sizeBorders();

        var ticking = false;
        window.addEventListener(
          'resize',
          function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
              ticking = false;
              sizeBorders();
            });
          },
          { passive: true }
        );

        var fired = false;
        var observer = null;
        var finish = function () {
          if (fired) return;
          fired = true;
          grid.classList.add('stepped');
          if (observer) observer.disconnect();
        };

        // Skip the observer entirely under reduced motion.
        if (!reduce && typeof IntersectionObserver !== 'undefined') {
          observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  // rAF so the is-armed baseline commits before .stepped.
                  window.requestAnimationFrame(finish);
                  observer.disconnect();
                }
              });
            },
            // threshold 0 + a bottom margin, NOT a ratio: when the grid is taller
            // than the viewport its intersection ratio can never reach a value
            // like 0.35, so a ratio threshold would leave the section hidden
            // forever. This fires once the grid's top passes ~82% of the fold.
            { threshold: 0, rootMargin: '0px 0px -18% 0px' }
          );
          observer.observe(grid);
        } else {
          // No observer available, or reduced motion (where the CSS keeps
          // everything visible anyway): show it immediately, unanimated.
          finish();
        }
      });
    },
  };

  // Treatments showcase — staggered card reveal, sparkline draw-in (CSS via
  // .is-in), sequential chat thread, and model-photo parallax.
  ns.showcase = {
    init: function () {
      var sections = document.querySelectorAll('.lg-kino-showcase');
      if (!sections.length) return;

      var reduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var runChat = function (chatEl) {
        var msgs = Array.prototype.slice.call(chatEl.querySelectorAll('[data-lg-chat-msg]'));
        if (!msgs.length) return;
        var typing = chatEl.querySelector('[data-lg-chat-typing]');
        var threads = Array.prototype.slice.call(chatEl.querySelectorAll('[data-lg-chat-thread]'));

        if (reduce) {
          threads.forEach(function (t) {
            t.classList.add('is-shown');
          });
          msgs.forEach(function (m) {
            m.classList.add('is-shown');
          });
          if (typing) typing.classList.remove('is-shown');
          return;
        }

        var i = 0;
        var showNext = function () {
          if (i >= msgs.length) {
            if (typing) typing.classList.remove('is-shown');
            return;
          }
          var msg = msgs[i];
          var thread = msg.closest ? msg.closest('[data-lg-chat-thread]') : null;
          var bubs = msg.parentNode;
          if (thread) thread.classList.add('is-shown'); // reveal avatar + group
          var isClinician = msg.getAttribute('data-sender') === 'clinician';
          var reveal = function () {
            if (typing) typing.classList.remove('is-shown');
            msg.classList.add('is-shown');
            var len = (msg.textContent || '').length;
            var delay = Math.min(2600, 900 + len * 52); // next bubble waits on this one's length
            i++;
            setTimeout(showNext, delay);
          };
          if (isClinician && typing) {
            bubs.appendChild(typing); // position the indicator inside this thread
            typing.classList.add('is-shown'); // 3-dot indicator, clinician only
            setTimeout(reveal, 1500 + Math.random() * 400); // ~1.5–1.9s
          } else {
            reveal();
          }
        };
        setTimeout(showNext, 500);
      };

      var initParallax = function (model, panel) {
        var ticking = false;
        var update = function () {
          ticking = false;
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var rect = panel.getBoundingClientRect();
          var center = rect.top + rect.height / 2;
          var progress = (center - vh / 2) / (vh / 2 + rect.height / 2);
          progress = Math.max(-1, Math.min(1, progress));
          model.style.setProperty('--lg-parallax', (progress * -30).toFixed(1) + 'px'); // ±30px
        };
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      };

      Array.prototype.forEach.call(sections, function (section) {
        var tz = section.querySelector('.lg-kino-showcase__tz');
        var chatEl = section.querySelector('[data-lg-chat]');

        var started = false;
        var start = function () {
          if (started) return;
          started = true;
          if (tz) tz.classList.add('is-in');
          if (chatEl) runChat(chatEl);
        };

        if (reduce || typeof IntersectionObserver === 'undefined' || !tz) {
          start();
        } else {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  start();
                  observer.disconnect();
                }
              });
            },
            { threshold: 0.15 }
          );
          observer.observe(tz);
        }

        var model = section.querySelector('.lg-kino-showcase__model');
        var panel = section.querySelector('.lg-kino-showcase__visual') || section;
        if (model && !reduce) initParallax(model, panel);
      });
    },
  };

  function boot() {
    ns.nav.init();
    ns.mobileMenu.init();
    ns.countUp.init();
    ns.ctaFinal.init();
    ns.modals.init();
    ns.how.init();
    ns.showcase.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ===== LIQUID_GOLD: Redesign sections — testimonials, blog slider, video modal ===== */

/* Testimonials — tabbed auto-advancing slider (section-scoped) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initTst(root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-lg-tst-tab]'));
    var cards = [].slice.call(root.querySelectorAll('[data-lg-tst-card]'));
    if (!cards.length) return;
    var DUR = parseInt(root.getAttribute('data-lg-tst-duration'), 10) || 5500;
    var i = 0, timer = null;
    var prev = root.querySelector('[data-lg-tst-prev]');
    var next = root.querySelector('[data-lg-tst-next]');
    function fill() {
      var bar = tabs[i] && tabs[i].querySelector('.lg-kino-tst__bar');
      if (!bar || reduce) return;
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(0)';
      void bar.offsetWidth;
      bar.style.transition = 'transform ' + DUR + 'ms linear';
      bar.style.transform = 'scaleX(1)';
    }
    function set(n) {
      i = (n + cards.length) % cards.length;
      cards.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k !== i) {
          var b = t.querySelector('.lg-kino-tst__bar');
          if (b) { b.style.transition = 'none'; b.style.transform = 'scaleX(0)'; }
        }
      });
      fill();
    }
    function play() { stop(); if (reduce) return; timer = setInterval(function () { set(i + 1); }, DUR); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { set(k); play(); }); });
    if (next) next.addEventListener('click', function () { set(i + 1); play(); });
    if (prev) prev.addEventListener('click', function () { set(i - 1); play(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () { set(i); play(); });
    set(0);
    play();
  }
  function boot() { document.querySelectorAll('[data-lg-tst]').forEach(initTst); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Health guide / blog slider — rail scroll + progress + background cross-fade */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initBlog(root) {
    var rail = root.querySelector('[data-lg-blog-rail]');
    var prev = root.querySelector('[data-lg-blog-prev]');
    var next = root.querySelector('[data-lg-blog-next]');
    var fill = root.querySelector('[data-lg-blog-fill]');
    if (rail && prev && next) {
      var step = function () {
        var c = rail.querySelector('.lg-kino-blog__card');
        if (!c) return rail.clientWidth;
        var g = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 18;
        return c.getBoundingClientRect().width + g;
      };
      var update = function () {
        if (!fill) return;
        var max = rail.scrollWidth - rail.clientWidth;
        var p = max > 0 ? rail.scrollLeft / max : 0;
        fill.style.width = (20 + p * 80) + '%';
      };
      prev.addEventListener('click', function () {
        var max = rail.scrollWidth - rail.clientWidth;
        if (rail.scrollLeft <= 2) rail.scrollTo({ left: max, behavior: 'smooth' });
        else rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        var max = rail.scrollWidth - rail.clientWidth;
        if (rail.scrollLeft >= max - 2) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    var bgs = [].slice.call(root.querySelectorAll('.lg-kino-blog__bg-img'));
    if (bgs.length > 1 && !reduce) {
      var bi = 0, timer = null;
      var rotate = function () { bgs[bi].classList.remove('is-active'); bi = (bi + 1) % bgs.length; bgs[bi].classList.add('is-active'); };
      var start = function () { timer = setInterval(rotate, 3500); };
      start();
      root.addEventListener('mouseenter', function () { if (timer) { clearInterval(timer); timer = null; } });
      root.addEventListener('mouseleave', function () { if (!timer) start(); });
    }
  }
  function boot() { document.querySelectorAll('[data-lg-blog]').forEach(initBlog); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Generic one-shot scroll reveal — adds .is-in the first time a [data-lg-reveal]
   section enters the viewport; each section's CSS decides what that animates.
   Reduced motion / no IO: paint in immediately. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initJrn(root) {
    if (root.dataset.lgRevealReady) return;
    root.dataset.lgRevealReady = '1';
    if (reduce || typeof IntersectionObserver === 'undefined') {
      root.classList.add('is-in');
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );
    observer.observe(root);
  }
  function boot(scope) {
    (scope || document).querySelectorAll('[data-lg-reveal]').forEach(initJrn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Benefits carousel — arrows step exactly one slide, on every viewport.
   The rail is a native scroll-snap scroller (free swipe/trackpad), so stepping
   is "scroll to index × slide pitch" rather than a transform offset. Pitch is
   measured from the live DOM so the card-width setting and the mobile
   breakpoint need no JS awareness. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVfx(root) {
    if (root.dataset.lgVfxReady) return;
    root.dataset.lgVfxReady = '1';

    var mask = root.querySelector('[data-lg-vfx-mask]');
    var track = root.querySelector('[data-lg-vfx-track]');
    var prev = root.querySelector('[data-lg-vfx-prev]');
    var next = root.querySelector('[data-lg-vfx-next]');
    if (!mask || !track) return;

    var slides = [].slice.call(track.children);
    if (!slides.length) return;

    // Distance from one slide's left edge to the next — card width plus gap.
    // Both rects shift together while scrolling, so the delta stays correct.
    function pitch() {
      if (slides.length < 2) return slides[0].getBoundingClientRect().width;
      return (
        slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left
      );
    }

    function maxScroll() {
      return Math.max(0, mask.scrollWidth - mask.clientWidth);
    }

    function currentIndex() {
      var p = pitch();
      return p > 0 ? Math.round(mask.scrollLeft / p) : 0;
    }

    function go(i) {
      var p = pitch();
      var clamped = Math.max(0, Math.min(i, slides.length - 1));
      mask.scrollTo({
        left: Math.min(clamped * p, maxScroll()),
        behavior: reduce ? 'auto' : 'smooth',
      });
    }

    function sync() {
      var max = maxScroll();
      if (prev) prev.disabled = mask.scrollLeft <= 2;
      if (next) next.disabled = mask.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { go(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { go(currentIndex() + 1); });
    mask.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-lg-vfx]').forEach(initVfx);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Video modal — YouTube lightbox (global, event-delegated) */
(function () {
  'use strict';
  var lastFocus = null;
  function modal() { return document.getElementById('lg-kino-modal-video'); }
  function open(id, cap) {
    var m = modal();
    if (!m || !id) return;
    var frame = m.querySelector('[data-lg-video-frame]');
    var capEl = m.querySelector('[data-lg-video-cap]');
    lastFocus = document.activeElement;
    if (capEl) capEl.textContent = cap || '';
    if (frame) {
      frame.innerHTML = '<iframe src="https://www.youtube.com/embed/' + encodeURIComponent(id) +
        '?autoplay=1&rel=0" title="' + (cap || 'Video').replace(/"/g, '') +
        '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    }
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = m.querySelector('.lg-kino-video-modal__close');
    setTimeout(function () { if (c) c.focus(); }, 50);
  }
  function close() {
    var m = modal();
    if (!m) return;
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    var frame = m.querySelector('[data-lg-video-frame]');
    if (frame) frame.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lg-open-video]');
    if (t) { e.preventDefault(); open(t.getAttribute('data-lg-video-id'), t.getAttribute('data-lg-video-cap')); return; }
    if (e.target.closest('[data-lg-video-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    var m = modal();
    if (e.key === 'Escape' && m && m.getAttribute('aria-hidden') === 'false') close();
  });
})();

/* Buy box — dose option radio toggle + CTA label sync (section-scoped).
   The CTA opens the shared protocol modal via the global [data-lg-open-protocol]
   handler above; here we only manage which dose is selected and mirror its label
   onto the CTA. */
(function () {
  'use strict';
  /* Detail tabs — swap the visible panel, roving tabindex for arrow keys. */
  function initTabs(box) {
    var wrap = box.querySelector('[data-lg-buybox-tabs]');
    if (!wrap) return;
    var tabs = [].slice.call(wrap.querySelectorAll('.lg-kino-buybox__tab'));
    var panels = [].slice.call(wrap.querySelectorAll('.lg-kino-buybox__panel'));
    if (!tabs.length) return;

    function show(i) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, n) {
        var on = n === i;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        show(next);
        tabs[next].focus();
      });
    });
  }

  function initBox(box) {
    initTabs(box);

    var options = [].slice.call(box.querySelectorAll('.lg-kino-buybox__option'));
    var ctaLabel = box.querySelector('.lg-kino-buybox__cta-label');
    var cta = box.querySelector('.lg-kino-buybox__cta');
    if (!options.length) return;

    function select(target) {
      options.forEach(function (o) {
        var active = o === target;
        o.classList.toggle('is-active', active);
        o.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      if (ctaLabel) {
        var label = target.getAttribute('data-lg-buybox-cta');
        if (label) ctaLabel.textContent = label;
      }
      // Mirror the selected dose's intake-form link onto the CTA. When present the
      // CTA navigates there (see below) instead of opening the protocol modal.
      if (cta) {
        var url = target.getAttribute('data-lg-buybox-url');
        if (url) cta.setAttribute('data-lg-buybox-url', url);
        else cta.removeAttribute('data-lg-buybox-url');
      }
    }

    options.forEach(function (o) {
      o.addEventListener('click', function () { select(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(o); }
      });
    });

    // If the selected dose has an intake-form link, go straight there. Stopping
    // propagation keeps the global [data-lg-open-protocol] handler from also
    // firing and opening the modal. With no link, the click bubbles and the
    // modal opens as before.
    if (cta) {
      cta.addEventListener('click', function (e) {
        var url = cta.getAttribute('data-lg-buybox-url');
        if (url) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = url;
        }
      });
    }
  }
  [].slice.call(document.querySelectorAll('.lg-kino-buybox')).forEach(initBox);

  // Theme editor: the section's markup is replaced on every setting change, so
  // re-bind the freshly rendered options and tabs.
  document.addEventListener('shopify:section:load', function (e) {
    [].slice.call(e.target.querySelectorAll('.lg-kino-buybox')).forEach(initBox);
  });
})();
